<template>
  <section class="section pt-1 bg-white">
    <div class="container">
      <h1 class="mb-4">{{ $t("help.platform.screen-panel.text") }}</h1>

      <div role="tablist">
        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col1' ? 'founded' : ''" v-b-toggle.col1>
              <div>{{ $t("help.platform.screen-panel.account.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col1" :visible="col == 'col1'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-0">
                {{ $t("help.platform.screen-panel.account.line-1") }}
              </p>

              <!-- <h5 class="mt-5">{{$t("help.organization.create.sample-screen")}}</h5> -->
              <img src="@/assets/images/help/account-dashboard.png" class="image" />
              <p class="mt-3">
                {{ $t("help.platform.screen-panel.account.line-2") }}
              </p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col2' ? 'founded' : ''" v-b-toggle.col2>
              <div>{{ $t("help.platform.screen-panel.organization.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col2" :visible="col == 'col2'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-0">
                {{ $t("help.platform.screen-panel.organization.line-1") }}
              </p>

              <!-- <h5 class="mt-5">{{$t("help.organization.create.sample-screen")}}</h5> -->
              <img src="@/assets/images/help/organization-panel-info.png" class="image" />

              <p class="mt-3">{{ $t("help.platform.screen-panel.organization.line-2") }}</p>
              <img src="@/assets/images/help/organization-panel.png" class="image" />
              <p class="mt-3">{{ $t("help.platform.screen-panel.organization.line-3") }}</p>
              <p class="mt-3">{{ $t("help.platform.screen-panel.organization.line-4") }}</p>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col3' ? 'founded' : ''" v-b-toggle.col3>
              <div>{{ $t("help.platform.screen-panel.risk.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col3" :visible="col == 'col3'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.screen-panel.risk.line-1") }}
              </p>
              <img src="@/assets/images/help/risk-panel-info.png" class="image" />
              <p class="mt-3">{{ $t("help.platform.screen-panel.risk.line-2") }}</p>
            </b-card-body>

            <b-card no-body class="custom-accordion shadow-none mb-3 ml-4">
              <b-card-header header-tag="header" role="tab">
                <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col4' ? 'founded' : ''" v-b-toggle.col4>
                  <div>{{ $t("help.platform.screen-panel.dashboard.text") }}</div>
                  <i class="mdi mdi-minus accor-plus-icon"></i>
                </a>
              </b-card-header>
              <b-collapse id="col4" :visible="col == 'col4'" accordion="help-accordionlist2" role="tabpanel">
                <b-card-body>
                  <p class="mb-3">
                    {{ $t("help.platform.screen-panel.dashboard.line-1") }}
                  </p>
                  <img src="@/assets/images/help/risk-dashboard.png" class="image" />
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="custom-accordion shadow-none mb-3 ml-4">
              <b-card-header header-tag="header" role="tab">
                <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col5' ? 'founded' : ''" v-b-toggle.col5>
                  <div>{{ $t("help.platform.screen-panel.risk-level.text") }}</div>
                  <i class="mdi mdi-minus accor-plus-icon"></i>
                </a>
              </b-card-header>
              <b-collapse id="col5" :visible="col == 'col5'" accordion="help-accordionlist2" role="tabpanel">
                <b-card-body>
                  <p class="mb-3">
                    {{ $t("help.platform.screen-panel.risk-level.line-1") }}
                  </p>
                  <img src="@/assets/images/help/risk-level.png" class="image" />
                  <p class="mt-3">{{ $t("help.platform.screen-panel.risk-level.line-2") }}</p>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="custom-accordion shadow-none mb-3 ml-4">
              <b-card-header header-tag="header" role="tab">
                <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col6' ? 'founded' : ''" v-b-toggle.col6>
                  <div>{{ $t("help.platform.screen-panel.corporate-risk.text") }}</div>
                  <i class="mdi mdi-minus accor-plus-icon"></i>
                </a>
              </b-card-header>
              <b-collapse id="col6" :visible="col == 'col6'" accordion="help-accordionlist2" role="tabpanel">
                <b-card-body>
                  <p class="mb-3">
                    {{ $t("help.platform.screen-panel.corporate-risk.line-1") }}
                  </p>
                  <img src="@/assets/images/help/corporate-risk.png" class="image" />

                  <a href="/risk/corporate-risk">
                    <p class="mt-3"><i class="bx bx-support"></i> {{ $t("help.platform.screen-panel.corporate-risk.line-2") }}</p>
                  </a>
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-card no-body class="custom-accordion shadow-none mb-3 ml-4">
              <b-card-header header-tag="header" role="tab">
                <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col7' ? 'founded' : ''" v-b-toggle.col7>
                  <div>{{ $t("help.platform.screen-panel.risk-list.text") }}</div>
                  <i class="mdi mdi-minus accor-plus-icon"></i>
                </a>
              </b-card-header>
              <b-collapse id="col7" :visible="col == 'col7'" accordion="help-accordionlist2" role="tabpanel">
                <b-card-body>
                  <p class="mb-3">
                    {{ $t("help.platform.screen-panel.risk-list.line-1") }}
                  </p>
                  <img src="@/assets/images/help/risk-list.png" class="image" />
                </b-card-body>
              </b-collapse>
            </b-card>
          </b-collapse>
        </b-card>

        <!-- <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col4' ? 'founded' : ''" v-b-toggle.col4>
              <div>{{ $t("help.platform.screen-panel.dashboard.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col4" :visible="col == 'col4'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.screen-panel.dashboard.line-1") }}
              </p>
              <img src="@/assets/images/help/risk-dashboard.png" class="image" />
              <p class="mt-3">{{ $t("help.platform.screen-panel.dashboard.line-2") }}</p>

            </b-card-body>
          </b-collapse>
        </b-card> -->

        <!-- <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col5' ? 'founded' : ''" v-b-toggle.col5>
              <div>{{ $t("help.platform.screen-panel.risk-level.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col5" :visible="col == 'col5'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.screen-panel.risk-level.line-1") }}
              </p>
              <img src="@/assets/images/help/risk-level.png" class="image" />
              <p class="mt-3">{{ $t("help.platform.screen-panel.risk-level.line-2") }}</p>

            </b-card-body>
          </b-collapse>
        </b-card> -->

        <!-- <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col6' ? 'founded' : ''" v-b-toggle.col6>
              <div>{{ $t("help.platform.screen-panel.corporate-risk.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col6" :visible="col == 'col6'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.screen-panel.corporate-risk.line-1") }}
              </p>
              <img src="@/assets/images/help/corporate-risk.png" class="image" />

              <a href="/risk/corporate-risk">
                <p class="mt-3"><i class="bx bx-support"></i> {{ $t("help.platform.screen-panel.corporate-risk.line-2") }}</p>
              </a>
            </b-card-body>
          </b-collapse>
        </b-card> -->

        <!-- <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col7' ? 'founded' : ''" v-b-toggle.col7>
              <div>{{ $t("help.platform.screen-panel.risk-list.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col7" :visible="col == 'col7'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.screen-panel.risk-list.line-1") }}
              </p>
              <img src="@/assets/images/help/risk-list.png" class="image" />
            </b-card-body>
          </b-collapse>
        </b-card> -->

        <b-card no-body class="custom-accordion shadow-none mb-3">
          <b-card-header header-tag="header" role="tab">
            <a href="javascript: void(0);" class="accordion-list collapsed" :class="col == 'col8' ? 'founded' : ''" v-b-toggle.col8>
              <div>{{ $t("help.platform.screen-panel.product.text") }}</div>
              <i class="mdi mdi-minus accor-plus-icon"></i>
            </a>
          </b-card-header>
          <b-collapse id="col8" :visible="col == 'col8'" accordion="help-accordionlist" role="tabpanel">
            <b-card-body>
              <p class="mb-3">
                {{ $t("help.platform.screen-panel.product.line-1") }}
              </p>
              <img src="@/assets/images/help/product.png" class="image" />
              <p class="mt-3">{{ $t("help.platform.screen-panel.product.line-2") }}</p>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      col: "col1",
    };
  },
  mounted() {
    setTimeout(() => {
      const { col } = this.$route.query;
      this.col = col;
      window.scrollTo({ top: 700, behavior: "smooth" });
    }, 500);
  },
};
</script>

<style scoped>
.founded {
  background: yellow !important;
}
.image {
  display: block;
  max-width: 100%;
}
</style>
